<template>
  <div>
    <v-app-bar app>
      <v-spacer />
      <v-toolbar-title>Password Generator</v-toolbar-title>
      <v-spacer />
    </v-app-bar>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>